export const percentChance = (percent: number) => {
  return Math.random() < percent / 100;
};
